import React from 'react';
import { WithStyles, withStyles } from '@mui/styles';
import { ClassNameMap } from '@mui/styles/withStyles';
import { withRouter, RouteComponentProps, useParams } from 'react-router-dom';
import Dashboard from '../../../../../layouts/Dashboard';
import styles from './styles';
import { useQuery } from '@apollo/client';
import { GetOrganisationResponse, getOrganisation } from './queries';
import ListEraCareQuestionnaireComponent from '../../../../../components/Global/EraCareQuestionnaire/List';
import CustomBackdrop from '../../../../../components/CustomBackdrop';

interface Props extends WithStyles<typeof styles>, RouteComponentProps {
  classes: ClassNameMap<string>;
}

interface UrlParams {
  organisation_id: string;
}

const ListEraCareQuestionnaireAdmin = ({ classes, history }: Props): React.ReactElement => {
  const { organisation_id } = useParams<UrlParams>();

  const { data: organisationInitQuery, loading: orgLoading } = useQuery<GetOrganisationResponse>(getOrganisation, { variables: { id: organisation_id }, fetchPolicy: 'no-cache' });

  const handleCreate = () => {
    history.push(`/admin/trusts/${organisation_id}/care-questionnaires/create`);
  };

  const handleEdit = (id: string) => {
    history.push(`/admin/trusts/${organisation_id}/care-questionnaires/${id}/edit`);
  };

  return (
    <Dashboard
      breadcrumbs={[
        { label: 'Trusts', link: '/admin/trusts' },
        { label: organisationInitQuery?.organisations_by_pk.name ?? '', link: `/admin/trusts/${organisation_id}` },
        { label: 'Nurtura Questionnaire' },
      ]}>
      <ListEraCareQuestionnaireComponent organisationId={organisation_id} handleCreate={handleCreate} handleEdit={handleEdit} />
      {orgLoading && <CustomBackdrop label="Loading" />}
    </Dashboard>
  );
};

export default withRouter(withStyles(styles)(ListEraCareQuestionnaireAdmin));
